export enum ResponseTypeEnum {
    ok = 0,
    mismatched = 1,
    error = 2,
  }
